import { createSlice } from '@reduxjs/toolkit';
import { toolbarConstants } from '../../constants/toolbar/toolbarConstants';
import _ from 'lodash';
// import eFaxIcon from '../../assets/eFaxEHR.svg';

const initialActions = [
  {
    icon: 'note_add',
    title: '',
    key: toolbarConstants.CREATE,
  },
  {
    icon: 'folder_open',
    title: '',
    key: toolbarConstants.OPEN,
  },
  {
    icon: 'print',
    title: '',
    key: toolbarConstants.PRINT,
  },
  {
    icon: 'save',
    title: '',
    key: toolbarConstants.SAVE,
  },
  {
    icon: 'send',
    title: '',
    key: toolbarConstants.SEND,
  },
  {
    icon: 'cancel',
    title: '',
    key: toolbarConstants.CANCEL,
  },
  {
    icon: 'edit',
    title: '',
    key: toolbarConstants.EDIT,
  },
  {
    icon: 'refresh',
    title: '',
    key: toolbarConstants.REFRESH,
  },
  {
    icon: 'cloud_sync',
    title: '',
    key: toolbarConstants.SYNC,
  },
  {
    icon: 'exit_to_app',
    title: '',
    key: toolbarConstants.EXIT_TO_APP,
  },
  {
    icon: 'content_copy',
    title: '',
    key: toolbarConstants.COPY,
  },
  {
    icon: 'delete',
    title: '',
    key: toolbarConstants.DELETE,
  },
  {
    icon: 'file_download',
    title: '',
    key: toolbarConstants.DOWNLOAD,
  },
  {
    icon: 'filter_alt',
    title: '',
    key: toolbarConstants.FILTER,
  },
  {
    icon: 'settings',
    title: '',
    key: toolbarConstants.SETTINGS,
  },
  {
    icon: 'library_add_check_rounded_icon',
    title: '',
    key: toolbarConstants.CHECK_STATUS,
  },
  {
    icon: 'playlist_add_circle_rounded_icon',
    title: '',
    key: toolbarConstants.SHOW_ERA,
  },
  {
    icon: 'sync_rounded_icon',
    title: '',
    key: toolbarConstants.SYNC_CLAIM,
  },
];

const initialState = {
  visibility: false,
  shouldShowEditSwitch: false,
  toolbarPossibleActions: [],
};

const helpAction = [
  {
    disabled: false,
    icon: 'help',
    key: 'HELP',
    title: 'Help',
    clickAction: () => window.open('https://www.enliv.com/help', '_blank'),
  },
];
const snackbarSlice = createSlice({
  name: 'toolbarSlice',
  initialState,
  reducers: {
    setToolbarButtons: (state, action) => {
      const { actions, module } = action?.payload;
      const editSwitch =
        typeof action?.payload?.editSwitch === 'boolean'
          ? action?.payload?.editSwitch
          : Boolean(actions.length);
      const visibility =
        typeof action?.payload?.visibility === 'boolean'
          ? action?.payload?.visibility
          : Boolean(actions.length);
      let shownActions = [];
      initialActions.forEach(act => {
        let existingAction = actions.find(f => f.key === act.key);
        shownActions.push({
          ...act,
          ...existingAction,
          disabled: existingAction
            ? existingAction.hasOwnProperty('disabled')
              ? existingAction?.disabled
              : false
            : true,
          title: `${_.capitalize(act.key)} ${
            act.key !== toolbarConstants.CANCEL ? (module ? module : '') : ''
          }`,
        });
      });
      shownActions.push(...helpAction);
      //temporary code starts for back button
      shownActions = shownActions.filter(
        f =>
          (f.key === toolbarConstants.CANCEL &&
            typeof f.clickAction === 'function') ||
          f.key !== toolbarConstants.CANCEL
      );
      //temporary code ends for back button
      state.message = visibility;
      state.toolbarPossibleActions = [...shownActions];
      state.editSwitch = editSwitch;
    },
  },
});

export const { setToolbarButtons } = snackbarSlice.actions;
export default snackbarSlice.reducer;
